import { render } from "./CollectionCardTraits.vue?vue&type=template&id=00b5f252"
import script from "./CollectionCardTraits.vue?vue&type=script&lang=js"
export * from "./CollectionCardTraits.vue?vue&type=script&lang=js"

import "./CollectionCardTraits.vue?vue&type=style&index=0&id=00b5f252&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__